import { useTranslation } from 'react-i18next';
import styles from './NoMatches.module.css';

/**
 * The Materials search's miss state, shared by the three panels the unified
 * search filters (board, inventory, waste) so the segment answers an empty
 * filter with one voice — three hand-rolled variants drifted apart within a
 * single change.
 */
export function NoMatches() {
  const { t } = useTranslation();
  return <p className={styles.noMatch}>{t('logistics.materials.noMatches')}</p>;
}
